import ReactComponent from '../../../assets/icons/calibrate.svg?react';
import type { FC } from 'react';
import { BaseIcon, IconProps } from './BaseIcon';

export const CalibrationIcon: FC<IconProps> = (props) => {
    return (
        <BaseIcon {...props}>
            <ReactComponent />
        </BaseIcon>
    );
};
